export default [
    {
        label: 'Every Morning at 8am (UTC)',
        value: 'every_morning_8am'
    },
    {
        label: 'Every Morning at 9am (UTC)',
        value: 'every_morning_9am'
    },
    {
        label: 'Every Monday Morning at 8am (UTC)',
        value: 'every_monday_8am'
    },
    {
        label: 'Every Monday Morning at 9am (UTC)',
        value: 'every_monday_9am'
    },
    {
        label: 'Every Day at 8am (UTC) and 3pm (UTC)',
        value: 'every_day_8am_and_3pm'
    }
];